/* YelVarí — interacciones propias (prefijo yv-) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.yv-reveal:not(.yv-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('yv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('yv-visible');
        io.unobserve(e.target);
        if (e.target.hasAttribute('data-yv-contar')) contar(e.target);
        e.target.querySelectorAll('[data-yv-contar]').forEach(contar);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function contar(el) {
    if (el.dataset.yvHecho) return;
    el.dataset.yvHecho = '1';
    var fin = parseFloat(el.getAttribute('data-yv-contar')) || 0;
    var sufijo = el.getAttribute('data-yv-sufijo') || '';
    if (reducido) { el.textContent = fin + sufijo; return; }
    var t0 = null, dur = 1600;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
      el.textContent = v.toLocaleString('es-MX') + sufijo;
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function initTilt() {
    if (reducido || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-yv-tilt]').forEach(function (card) {
      var fuerza = parseFloat(card.getAttribute('data-yv-tilt')) || 8;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--ry', (x * fuerza) + 'deg');
        card.style.setProperty('--rx', (-y * fuerza) + 'deg');
      });
      card.addEventListener('mouseleave', function () {
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--rx', '0deg');
      });
    });
  }

  function initParallax() {
    if (reducido) return;
    var els = document.querySelectorAll('[data-yv-parallax]');
    if (!els.length) return;
    var pendiente = false;
    function actualizar() {
      pendiente = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var intensidad = parseFloat(el.getAttribute('data-yv-parallax')) || 40;
        var centro = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.setProperty('--yv-parallax', (-centro * intensidad - intensidad / 2) + 'px');
      });
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(actualizar); }
    }, { passive: true });
    actualizar();
  }

  function initBlobs() {
    if (reducido) return;
    var blobs = document.querySelectorAll('[data-yv-mover]');
    if (!blobs.length) return;
    var pendiente = false;
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        var y = window.scrollY;
        blobs.forEach(function (b) {
          var v = parseFloat(b.getAttribute('data-yv-mover')) || 0.15;
          b.style.transform = 'translate3d(0,' + (y * v) + 'px,0)';
        });
      });
    }, { passive: true });
  }

  /* ---------- Página de producto ---------- */
  function initProducto() {
    document.querySelectorAll('[data-yv-producto]').forEach(function (raiz) {
      var datosEl = raiz.querySelector('[data-yv-variantes]');
      var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
      var principal = raiz.querySelector('[data-yv-principal]');
      var minis = raiz.querySelectorAll('[data-yv-mini]');
      var inputId = raiz.querySelector('form input[name="id"]');
      var precio = raiz.querySelector('[data-yv-precio]');
      var antes = raiz.querySelector('[data-yv-antes]');
      var ahorro = raiz.querySelector('[data-yv-ahorro]');
      var boton = raiz.querySelector('[data-yv-boton]');
      var botonTxt = boton ? boton.querySelector('span') : null;
      var stock = raiz.querySelector('[data-yv-stock]');
      var formato = raiz.getAttribute('data-yv-formato') || '${{amount}}';
      var txtAgregar = raiz.getAttribute('data-yv-txt-agregar');
      var txtAgotado = raiz.getAttribute('data-yv-txt-agotado');

      function dinero(centavos) {
        var n = (centavos / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return formato.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
      }

      function mostrarFoto(src, srcset, mini) {
        if (!principal) return;
        principal.classList.add('yv-cambiando');
        setTimeout(function () {
          principal.src = src;
          if (srcset) principal.srcset = srcset;
          principal.classList.remove('yv-cambiando');
        }, 180);
        minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
      }

      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          mostrarFoto(m.getAttribute('data-src'), m.getAttribute('data-srcset'), m);
        });
      });

      function seleccion() {
        var sel = [];
        raiz.querySelectorAll('[data-yv-opcion]').forEach(function (fs) {
          var marcado = fs.querySelector('input:checked');
          sel.push(marcado ? marcado.value : null);
          var etiqueta = fs.querySelector('[data-yv-opcion-valor]');
          if (etiqueta && marcado) etiqueta.textContent = marcado.value;
        });
        return sel;
      }

      function marcarDisponibles(sel) {
        raiz.querySelectorAll('[data-yv-opcion]').forEach(function (fs, i) {
          fs.querySelectorAll('.yv-prod__valor').forEach(function (v) {
            var val = v.querySelector('input').value;
            var existe = variantes.some(function (vr) {
              return vr.options.every(function (o, j) { return j === i ? o === val : (sel[j] === null || o === sel[j]); }) && vr.available;
            });
            v.classList.toggle('yv-prod__valor--no', !existe);
          });
        });
      }

      function actualizar() {
        var sel = seleccion();
        var v = variantes.find(function (vr) {
          return vr.options.every(function (o, i) { return o === sel[i]; });
        });
        marcarDisponibles(sel);
        if (!v) {
          if (boton) { boton.setAttribute('disabled', 'disabled'); if (botonTxt) botonTxt.textContent = raiz.getAttribute('data-yv-txt-nodisp'); }
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        var hayAntes = v.compare_at_price && v.compare_at_price > v.price;
        if (antes) { antes.textContent = hayAntes ? dinero(v.compare_at_price) : ''; antes.hidden = !hayAntes; }
        if (ahorro) {
          ahorro.hidden = !hayAntes;
          if (hayAntes) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        }
        if (boton) {
          if (v.available) { boton.removeAttribute('disabled'); if (botonTxt) botonTxt.textContent = txtAgregar; }
          else { boton.setAttribute('disabled', 'disabled'); if (botonTxt) botonTxt.textContent = txtAgotado; }
        }
        if (stock) stock.hidden = !v.available;
        if (v.featured_media && v.featured_media.preview_image) {
          var mini = raiz.querySelector('[data-yv-mini][data-media-id="' + v.featured_media.id + '"]');
          if (mini) mostrarFoto(mini.getAttribute('data-src'), mini.getAttribute('data-srcset'), mini);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      raiz.querySelectorAll('[data-yv-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });
      if (variantes.length > 1) marcarDisponibles(seleccion());

      var cant = raiz.querySelector('[data-yv-cantidad]');
      if (cant) {
        var campo = cant.querySelector('input');
        cant.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(campo.value, 10) || 1;
            n += b.getAttribute('data-paso') === '+' ? 1 : -1;
            campo.value = Math.max(1, n);
          });
        });
      }
    });
  }

  function initPestanas() {
    document.querySelectorAll('[data-yv-catalogo]').forEach(function (raiz) {
      if (raiz.dataset.yvListo) return;
      raiz.dataset.yvListo = '1';
      var tabs = raiz.querySelectorAll('.yv-pestana');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var activa = t === tab;
            t.setAttribute('aria-selected', activa ? 'true' : 'false');
            var panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) {
              panel.hidden = !activa;
              if (activa) panel.querySelectorAll('.yv-reveal').forEach(function (el) { el.classList.add('yv-visible'); });
            }
          });
        });
      });
    });
  }

  function init() {
    initPestanas();
    initReveal();
    initTilt();
    initParallax();
    initBlobs();
    initProducto();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { initReveal(); initTilt(); initParallax(); });
})();
